<template>
    <p class="fw-bold">Access to one-to-one financial coaching</p>
    <p>
        When you're thinking about your retirement plans, it's natural to have questions about your finances and the choices available to you. One-to-one
        financial coaching gives you the opportunity to speak confidentially with a qualified financial professional and receive personalised
        guidance tailored to your situation.
    </p>
    <p>
        As a member of the {{ schemeName }}, you have access to independent one-to-one financial coaching at no cost. Whether you want help 
        understanding your retirement options, the tax implications of your pensions, or simply need reassurance as you plan for the next stage of your
        life, our financial coaches are here to support you.
    </p>
    <p>
        To book your free coaching session, please click the link below.
    </p>
    <button class="btn btn-secondary btn-book" @click="onBookCoachingClicked">Book your free coaching session</button>

    <p class="mt-4 fst-italic text-muted">
        <small>
            Disclaimer: Please note that the one-to-one coaching service is designed to provide guidance, education, and support. 
            It is <strong>NOT</strong> a replacement for independent financial advice.
        </small>
    </p>
    <p class="fst-italic text-muted">
        <small>
            The coaches are not authorised or regulated to provide individual financial advice in the UK and cannot recommend specific 
            financial products or actions. If you require regulated financial advice, you should seek assistance from a professional 
            financial adviser who is authorised to offer advice tailored to your personal circumstances.
        </small>
    </p>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import FinalSalaryScheme from '@/guiide/ts/assets/finalsalary/finalSalaryScheme';
import { useStore } from 'vuex';

const store = useStore();

const schemeName = ref("");

onMounted(() => {
    setSchemeName();
})

watch(
    () => store.state.retiree,
    () => {
        setSchemeName();
    }
);

function setSchemeName() {
    if (!store.state.retiree) {
        return;
    }

    const schemeInfo: FinalSalaryScheme = store.state.retiree.finalSalaries.schemes[0];
    schemeName.value = schemeInfo.name;
}

function onBookCoachingClicked() {
    window.open('https://example.com', '_blank');
}

</script>
